// extracted by mini-css-extract-plugin
export default {"actionLabel":"action-label__ZFj94Yif","label":"label__uZA8b9z6","actionBtn":"action-btn__y9WvKdCg"};